var _a;
import { IdDomElement } from "../../constants/IdDomElement";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { gridConfig } from "../../setup/gridConfig";
import { utilGrid } from "../../utils/grid/utilGrid";
import { OutskirtBuildingCafe } from "../cafe/OutskirtBuildingCafe";
import { OutskirtBuildingDoghouse } from "../doghouse/OutskirtBuildingDoghouse";
import { OutskirtBuildingExternalBarn } from "../external-barn/OutskirtBuildingExternalBarn";
import { OutskirtBuildingHarbor } from "../harbor/OutskirtBuildingHarbor";
import { IdIsoSortingGroup } from "../iso/IdIsoSortingGroup";
import { OutskirtBuildingLibrary } from "../library/OutskirtBuildingLibrary";
import { IdAssetBundleCore } from "../loading/IdAssetBundleCore";
import { OutskirtBuildingMarket } from "../market/OutskirtBuildingMarket";
import { OutskirtBuildingNursery } from "../nursery/OutskirtBuildingNursery";
import { OutskirtBuildingPier } from "../pier/OutskirtBuildingPier";
import { LayerBackground } from "../player-base/layers/LayerBackground";
import { LayerPlayerBaseBuildingPlacement } from "../player-base/layers/LayerPlayerBaseBuildingPlacement";
import { LayerPlayerBaseBuildings } from "../player-base/layers/LayerPlayerBaseBuildings";
import { LayerPlayerBaseDirt } from "../player-base/layers/LayerPlayerBaseDirt";
import { LayerPlayerBaseFence } from "../player-base/layers/LayerPlayerBaseFence";
import { LayerPlayerBaseGrid } from "../player-base/layers/LayerPlayerBaseGrid";
import { LayerPlayerBaseLockedGround } from "../player-base/layers/LayerPlayerBaseLockedGround";
import { LayerPlayerBaseUnlockedGround } from "../player-base/layers/LayerPlayerBaseUnlockedGround";
import { ScenePlayerBaseCanvas } from "../player-base/ScenePlayerBaseCanvas";
import { OutskirtBuildingThemedEvent } from "../themed-events/OutskirtBuildingThemedEvent";
import { OutskirtBuildingTournamentTent } from "../tournament-building/OutskirtBuildingTournamentTent";
import { OutskirtBuildingWatertower } from "../watertower/OutskirtBuildingWatertower";
import { mapOutskirtsPosition } from "./mapOutskirtsPosition";
import { BF2SceneLoadingInitial } from "./scenes/BF2SceneLoadingInitial";
import { BF2ScenePlayerBaseDOM } from "./scenes/BF2ScenePlayerBaseDOM";
import { IdScene } from "./types/IdScene";
var originBaseX = gridConfig.originBaseX, originBaseY = gridConfig.originBaseY;
var worldWidth = 6824;
var worldHeight = 4898;
// FIXME: find a formula to handle zoom on different screen sizes.
var screenSizeZoomModifier = 1;
var zoom = {
    initial: {
        x: worldWidth * screenSizeZoomModifier * 0.45,
        y: worldHeight * screenSizeZoomModifier * 0.45,
    },
    max: {
        x: worldWidth * screenSizeZoomModifier * 0.7,
        y: worldHeight * screenSizeZoomModifier * 0.7,
    },
    min: {
        x: worldWidth * screenSizeZoomModifier * 0.25,
        y: worldHeight * screenSizeZoomModifier * 0.25,
    },
};
if (!utilGrid.gridConfig) {
    utilGrid.setup(gridConfig);
}
var topX = 5100;
var topY = 2280;
var viewportX = topX * 0.45 - window.innerWidth * 0.3;
var viewportY = topY * 0.45 + window.innerHeight * 0.2;
export var scenes = (_a = {},
    _a[IdScene.Loading] = {
        domComponent: BF2SceneLoadingInitial,
        sceneId: IdScene.Loading,
    },
    _a[IdScene.PlayerBase] = {
        assetBundleDependencies: [IdAssetBundleCore.Initial],
        canvasComponent: ScenePlayerBaseCanvas,
        config: {
            layers: [
                {
                    type: LayerBackground,
                    x: 0,
                    y: 0,
                },
                {
                    type: LayerPlayerBaseUnlockedGround,
                    x: originBaseX,
                    y: originBaseY,
                },
                {
                    type: LayerPlayerBaseDirt,
                    x: originBaseX,
                    y: originBaseY,
                },
                {
                    type: LayerPlayerBaseGrid,
                    x: originBaseX,
                    y: originBaseY,
                },
                {
                    id: IdOutskirtBuildings.Harbor,
                    interactive: true,
                    type: OutskirtBuildingHarbor,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Harbor).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Harbor).y,
                },
                {
                    id: IdOutskirtBuildings.Pier,
                    interactive: true,
                    type: OutskirtBuildingPier,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Pier).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Pier).y,
                },
                {
                    id: IdOutskirtBuildings.ExternalBarn,
                    interactive: true,
                    type: OutskirtBuildingExternalBarn,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.ExternalBarn).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.ExternalBarn).y,
                },
                {
                    id: IdOutskirtBuildings.Watertower,
                    interactive: true,
                    type: OutskirtBuildingWatertower,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Watertower).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Watertower).y,
                },
                {
                    id: IdOutskirtBuildings.Doghouse,
                    type: OutskirtBuildingDoghouse,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Doghouse).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Doghouse).y,
                },
                {
                    id: IdOutskirtBuildings.TournamentTent,
                    interactive: true,
                    type: OutskirtBuildingTournamentTent,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.TournamentTent).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.TournamentTent).y,
                },
                {
                    id: IdOutskirtBuildings.Nursery,
                    type: OutskirtBuildingNursery,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Nursery).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Nursery).y,
                },
                {
                    id: IdOutskirtBuildings.Library,
                    interactive: true,
                    type: OutskirtBuildingLibrary,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Library).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Library).y,
                },
                {
                    id: IdOutskirtBuildings.Cafe,
                    interactive: true,
                    type: OutskirtBuildingCafe,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Cafe).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Cafe).y,
                },
                {
                    id: IdOutskirtBuildings.ThemedEvent,
                    interactive: true,
                    type: OutskirtBuildingThemedEvent,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.ThemedEvent).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.ThemedEvent).y,
                },
                {
                    id: IdOutskirtBuildings.Market,
                    type: OutskirtBuildingMarket,
                    x: mapOutskirtsPosition.get(IdOutskirtBuildings.Market).x,
                    y: mapOutskirtsPosition.get(IdOutskirtBuildings.Market).y,
                },
                {
                    isoSortingGroup: IdIsoSortingGroup.Buildings,
                    type: LayerPlayerBaseBuildings,
                    x: originBaseX,
                    y: originBaseY,
                },
                {
                    isoSortingGroup: IdIsoSortingGroup.Buildings,
                    type: LayerPlayerBaseFence,
                    x: originBaseX,
                    y: originBaseY,
                },
                {
                    isoSortingGroup: IdIsoSortingGroup.Buildings,
                    type: LayerPlayerBaseLockedGround,
                    x: originBaseX,
                    y: originBaseY,
                },
                {
                    isoSortingGroup: IdIsoSortingGroup.BuildingPlacement,
                    type: LayerPlayerBaseBuildingPlacement,
                    x: originBaseX,
                    y: originBaseY,
                },
            ],
            viewport: {
                divWheel: document.getElementById(IdDomElement.CanvasMain),
                left: viewportX,
                top: viewportY,
                worldHeight: worldHeight,
                worldWidth: worldWidth,
                zoom: zoom,
            },
        },
        domComponent: BF2ScenePlayerBaseDOM,
        sceneId: IdScene.PlayerBase,
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/scenes.ts
// module id = 857
// module chunks = 3